// import { mapGetters, mapActions } from 'vuex';
import ResponsiveHeader from '@/components/sections/ResponsiveHeader/ResponsiveHeader.vue';
import ResponsiveContent from '@/components/sections/ResponsiveContent/ResponsiveContent.vue';

export default {
  name: 'dashboard',
  components: {
    ResponsiveHeader,
    ResponsiveContent,
  },
  data() {
    return {

    };
  },
  computed: {

  },
  methods: {

  },
  created() {

  },
};
